import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from './context/PermissionContext';

const ProtectedInterfaceRoute = ({ children, interfacePath }) => {
  const { isAdmin, isOwner, hasAccessToPath, loading } = usePermissions();
  const location = useLocation();

  // Show nothing while loading permissions
  if (loading) {
    return null;
  }

  // Admins and owners have access to everything
  if (isAdmin || isOwner) {
    return children;
  }

  // Extract the interface path from the current route if not provided
  const pathToCheck = interfacePath || location.pathname.replace('/dashboard/', '');

  // Check if user has access to this interface
  if (!hasAccessToPath(pathToCheck)) {
    // Redirect to dashboard home if no access
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedInterfaceRoute;
